/* ==========================================================================
   Design tokens — єдине джерело правди для кольорів, типографіки, анімацій.
   Усі значення взяті з брифу. Міняй тут — зміниться всюди.
   ========================================================================== */
:root {
  /* --- Палітра --- */
  --color-green-100: #B1E4B7; /* основний світло-зелений (фон Варіант 2) */
  --color-green-300: #85BC8C; /* зелений (бордер Варіант 2 / hover) */
  --color-green-500: #6D9772; /* темно-зелений (active / акцент) */
  --color-white:     #FFFFFF;
  --color-black:     #000000;

  /* Семантичні аліаси */
  --bg:          var(--color-white);
  --fg:          var(--color-black);
  --accent:      var(--color-green-100);
  --accent-edge: var(--color-green-300);
  --accent-deep: var(--color-green-500);

  /* --- Типографіка --- */
  --font-heavy:   'Helvetica Neue LT W1G 85 Heavy', Helvetica, sans-serif;
  --font-body:    'Helvetica Neue LT W1G 55 Roman', Helvetica, sans-serif;

  /* Стиль тексту кнопок (з брифу) */
  --btn-font-family:     var(--font-body);
  --btn-font-weight:     400;          /* 55 Roman */
  --btn-font-size:       24px;
  --btn-line-height:     0.9;          /* 90% */
  --btn-letter-spacing:  -0.02em;      /* -2% */

  /* Розміри кнопок */
  --btn-height-sm: 39px;
  --btn-height-lg: 61px;
  --btn-radius:    10px;
  --btn-border:    2px;

  /* --- Анімації --- */
  /* мікро-взаємодії (ховери кнопок/карток) — навмисно швидко */
  --motion-duration: 80ms;
  --motion-ease: ease-in-out;
  --transition: var(--motion-duration) var(--motion-ease);

  /* макро: інтро панелей — ОДИН важіль на швидкість усіх секцій */
  --panel-motion-duration: 900ms;

  /* --- Розкладка --- */
  --container-pad-x:  clamp(24px, 5vw, 48px);
  --container-pad-y:  clamp(8px, 2vw, 40px);
  --section-gap:      clamp(48px, 8vw, 120px);
  --container-width: 1440px;
  --container-height: 800px;
}

@media (prefers-reduced-motion: reduce) {
  :root {
    --transition: 0ms linear;
  }
}
